<template>
  <div class="mobile-comment-table-container">
    <div class="table-title">
      <div class="title-left">
        <i class="el-icon-s-management" />流程记录
      </div>
    </div>
    <!-- 流程记录 -->
    <div class="step-container">
      <template v-for="(item, index) in flowData">
        <div class="step-one" :key="item.id">
          <div class="step-title">第{{index + 1}}步 {{item.historyActivityName}}</div>
          <div class="step-content">
            <div class="step-line">
              <span class="step-person">{{item.assigneeName}}</span>主办,
              <span class="work-status" v-if="item.workStatusStr == '办理中'">{{item.workStatusStr}} {{item.historyActivityDurationTime != ''?`,已用时：${item.historyActivityDurationTime}`:''}}</span> 
              <span class="work-status" v-else>{{item.workStatusStr}} {{item.historyActivityDurationTime != ''?`,用时：${item.historyActivityDurationTime}`:''}}</span> 
            </div>
            <div class="step-line step-time">开始于: {{item.claimTime?item.claimTime:item.createTime}}</div>
            <div class="step-line step-time">结束于: {{item.endTime}}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobileCommentTable',
  data() {
    return {
    }
  },
  props: {
    flowData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },  
  mounted() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.mobile-comment-table-container{
  .table-title{
    width: 100%;
    height: 1rem;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    line-height: 1rem;
    margin-top: .2rem;
    padding-left: .3rem;
    padding-right: .3rem;
    .title-left{
      font-size: 0.38rem;
      color: #666;
      font-weight: 600;
    }
  }
  .step-container{
    .step-one{
      .step-title{
        font-size: .38rem;
        color: #999;
        line-height: 1rem;
        padding-left: .3rem;
        padding-right: .3rem;        
      }
      .step-content{
        background-color: #fff;
        // padding-left: .3rem;
        // padding-right: .3rem;
        padding: .2rem .3rem;
        border-width: 1px;
        border-style: solid;
        border-color: #f2f2f2;
        border-left: 0px;
        border-right: 0px;        
        .step-line{
          font-size: .36rem;
          color: #333;
          line-height: .55rem;
          .step-person{
            color: #409eff;
          }
        }
        .step-time{
          font-size: .36rem;
          color: #999;
        }
      }
    }
  }
}
</style>